import { ActionContext, ActionTree } from 'vuex';

import { RootState } from '@/store';
import { State } from './state';
import { Mutations, MutationTypes } from './mutations';

import { Status } from '@/models/CommonModels';

import i18n from '@/i18n';
import { loadLocaleMessages } from '@/i18n-loader';
type AppLocale = 'de' | 'en';

export enum ActionTypes {
  SetStatus = 'SETSTATUS',
  ToggleSidebar = 'TOGGLESIDEBAR',
  SetLanguage = 'SETLANGUAGE',
}

type ActionArguments = Omit<ActionContext<State, RootState>, 'commit'> & {
  commit<K extends keyof Mutations>(key: K, payload: Parameters<Mutations[K]>[1]): ReturnType<Mutations[K]>;
};

export type Actions = {
  [ActionTypes.SetStatus](context: ActionArguments, status: Status): void;
  [ActionTypes.ToggleSidebar](context: ActionArguments): void;
  [ActionTypes.SetLanguage](context: ActionArguments, lang: string): void;
};

export const actions: ActionTree<State, RootState> & Actions = {
  [ActionTypes.SetStatus]({ commit }: ActionArguments, status: Status) {
    commit(MutationTypes.SetStatus, status);
  },

  [ActionTypes.ToggleSidebar]({ commit, state }: ActionArguments) {
    const status = state.status;
    status.sidebarCollapsed = !status.sidebarCollapsed;
    commit(MutationTypes.SetStatus, status);
  },

  async [ActionTypes.SetLanguage]({ commit }: ActionArguments, lang: AppLocale) {
    await loadLocaleMessages(lang);
    i18n.global.locale.value = lang;
    commit(MutationTypes.SetLanguage, lang);
  },
};
